import { Component } from '@angular/core';

@Component({
  selector: 'app-flowpilot-chats-container',
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    <div
      class="border-dune-100 bg-dune-25 dark:bg-dune-900 dark:border-dune-800 relative flex h-full min-h-0 min-w-0 shrink-0 flex-col gap-y-4 rounded-xl border p-2">
      <ng-content />
    </div>
  `,
})
export class FlowpilotChatsContainerComponent {}
